// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"5b5d1d15","110":"31452020","502":"dec4c112","648":"6a518ef0","747":"24e8ca88","761":"e79707ec","835":"bdec5a3a","940":"911b7dab"}[chunkId] + ".chunk.css";
};